<template>
  <div class="home">
    <el-container>
      <el-header>
          <div class="left_logo"><img src="../assets/logo1.png" alt="" style="height: 24px;margin-bottom: -5px;margin-right: 5px;">升维服务平台</div>
          <div class="right_main">
              <ul>
                 <router-link :to="{ path: '/sellinput'}">
                   <li :class="{'active':sellinput}" @click="sellManage()">销售管理</li>
                 </router-link>
                 <router-link :to="{ path: '/orderbillcount' }">  
                  <li :class="{'active':billmanage}" @click="billmanages()">对账单管理</li>
                 </router-link>
                 <router-link :to="{ path: '/orderfrom' }">
                    <li :class="{'active':stock}" @click="stockManage()">
                      库存管理
                    </li>
                 </router-link>
                  <router-link :to="{ path: '/numbermanage' }">
                    <li :class="{'active':number}" @click="numberMange()">
                      账号管理
                    </li>
                  </router-link>
              </ul>
              <div class="head">
                  <el-dropdown>
                  <!-- <el-button  v-preventReClick type="primary">
                    
                  </el-button> -->
                  <span class="el-dropdown-link">
                    {{username}}
                  </span>
                  <el-dropdown-menu slot="dropdown" style="margin-top:-15px!important;">
                    <div @click="modifypwd()" style="padding:8px 15px;font-size:14px;cursor:pointer">修改密码</div>
                    <div @click="logout()" style="padding:8px 15px;font-size:14px;cursor:pointer">退出账号</div>
                    <!-- <el-dropdown-item >修改密码</el-dropdown-item>
                    <el-dropdown-item @click="logout()">退出账号</el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="menu" style="border-bottom: 1px solid #DCDFE6;">
                    <el-breadcrumb separator="">
                      <el-breadcrumb-item 
                      v-for="(item,index) in breadList"
                      :key="index"
                      :to="{ path: item.path }">{{item.name}}</el-breadcrumb-item>
                    </el-breadcrumb>
              </div>
          </div>
      </el-header>
      <el-container>
        <el-aside width="200px">
                <el-row>
                  <el-col :span="24">
                  <el-menu
                   :default-active="$route.path"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose"
                    background-color="#545c64"
                    text-color="#fff"
                    active-text-color="#ffd04b"
                    router
                    >

                    <!-- 库存管理 -->
                    <div class="stock" :class="{block:stock,none:!stock}">
                         <el-menu-item index="/orderfrom"><i class="el-icon-edit-outline"></i>订货单</el-menu-item>
                        <el-menu-item index="/stock"><i class="el-icon-edit-outline"></i>库存管理</el-menu-item>
                        <el-menu-item index="/returnorder"><i class="el-icon-edit-outline"></i>退货单</el-menu-item>
                    </div>
                     <!-- 账号管理 -->
                    <div class="number" :class="{block:number,none:!number}">
                         <el-menu-item index="/numbermanage"><i class="el-icon-edit-outline"></i><span>账号管理</span></el-menu-item>
                    </div>
                    <!-- 对账单管理 -->
                    <div class="bill" :class="{block:billmanage,none:!billmanage}">
                       <el-menu-item index="/orderbillcount"><i class="el-icon-edit-outline"></i><span>对账单统计</span></el-menu-item>
                    </div>
                  <!-- 销售管理 -->
                    <div class="sellinput" :class="{block:sellinput,none:!sellinput}">
                         <el-menu-item index="/sellinput"><i class="el-icon-edit-outline"></i><span>销售信息录入</span></el-menu-item>
                         <el-submenu index="1">
                          <template slot="title"><i class="el-icon-edit-outline"></i>销售订单管理</template>
                          <el-menu-item index="/waitorder">待核保订单</el-menu-item>
                          <el-menu-item index="/waitpayorder">待支付订单</el-menu-item>
                          <el-menu-item index="/fulfilorder">已完成订单</el-menu-item>
                          <el-menu-item index="/cancelledorder">已取消订单</el-menu-item>
                          <el-menu-item index="/failorder">核保失败订单</el-menu-item>
                          <el-menu-item index="/draftbox">草稿箱订单</el-menu-item>
                        </el-submenu>
                        <el-menu-item index="/voidapply"><i class="el-icon-edit-outline"></i><span>作废申请</span></el-menu-item>
                        <!-- <el-submenu index="2">
                            <template slot="title"><i class="el-icon-edit-outline"></i>销售订单作废申请</template>
                            <el-menu-item index="/voidapply">作废申请</el-menu-item>
                        </el-submenu> -->
                    </div>
                  </el-menu>
                </el-col>
                </el-row>
        </el-aside>
        <el-main>
           <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
     <!-- 修改密码 -->
      <el-dialog
      title="修改密码"
      :visible.sync="dialogVisiblepwd"
      :close-on-click-modal="false"
      width="30%"
      >
      <div class="froms">
        <el-form :model="ruleFormpwd" status-icon :rules="rulespwd" ref="ruleFormpwd" label-width="100px" class="demo-ruleForm">
              <el-form-item label="原密码" prop="oldpass">
                  <el-input type="password" v-model="ruleFormpwd.oldpass" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="pass">
                  <el-input type="password" v-model="ruleFormpwd.pass" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="checkPass">
                  <el-input type="password" v-model="ruleFormpwd.checkPass" autocomplete="off"></el-input>
              </el-form-item>
              </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button  v-preventReClick @click="dialogVisiblepwd = false">取 消</el-button>
          <el-button  v-preventReClick type="primary" @click="submitFormpwd()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {updatePassword} from '../axios/api'
export default {
  name: 'App',
  data(){
    var validatePass = (rule, value, callback) => {
        if (value === '') {
        callback(new Error('请输入密码'));
        } else {
        if (this.ruleFormpwd.checkPass !== '') {
            this.$refs.ruleFormpwd.validateField('checkPass');
        }
        callback();
        }
    };
    var validatePass2 = (rule, value, callback) => {
        if (value === '') {
        callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleFormpwd.pass) {
        callback(new Error('两次输入密码不一致!'));
        } else {
        callback();
        }
    };
    return{
      stock:true,
      number:false,
      sellinput:false,
      billmanage:false,
      breadList: [], // 路由集合
      dialogVisiblepwd:false,
      username:'',
      ruleFormpwd: {
                pass: '',
                checkPass: '',
                oldpass: ''
      },
      rulespwd: {
          pass: [
              {required: true, validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
              { required: true,validator: validatePass2, trigger: 'blur' }
          ],
          oldpass: [
              { required: true, message: '请输入原密码', trigger: 'blur' }
          ]
      }
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
    this.username = window.localStorage.getItem('name')
    console.log(window.localStorage.getItem('state'))
    if(window.localStorage.getItem('state') == 4){
        this.numberMange()
    }else if(window.localStorage.getItem('state') == 3){
        this.stockManage()
    }else if(window.localStorage.getItem('state') == 1){
        this.sellManage()
    }else if(window.localStorage.getItem('state') == 2){
      this.billmanages()
    }
  },

  methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      billmanages(){
        this.stock = false
        this.number = false
        this.sellinput = false
        this.billmanage = true
         window.localStorage.setItem('state',2)
      },
      stockManage(){
        this.stock = true
        this.number = false
          this.sellinput = false
          this.billmanage = false
         window.localStorage.setItem('state',3)
      },
      numberMange(){
        this.stock = false
        this.number = true
          this.sellinput = false
          this.billmanage = false
        window.localStorage.setItem('state',4)
      },
      sellManage(){
        this.stock = false
        this.number = false
        this.sellinput = true
        this.billmanage = false
        window.localStorage.setItem('state',1)
      },
      getBreadcrumb() {
        let matched = this.$route.matched;
        this.breadList = matched;
      },
      modifypwd(){
        console.log(123)
        this.dialogVisiblepwd = true
      },
      logout(){
        this.$confirm('确认退出该账号吗?', '退出', {
             confirmButtonText: '确定',
             cancelButtonText: '取消',
             closeOnClickModal:false,
             type: 'warning'
             }).then(() => {
             window.localStorage.removeItem('name')
             window.localStorage.removeItem('loginNumber')
             window.localStorage.removeItem('token')
             window.localStorage.removeItem('shopId')
             window.localStorage.removeItem('state')
             window.localStorage.removeItem('ids')
             window.localStorage.removeItem('month')
             window.localStorage.removeItem('months')
             this.$router.push('/login')
             }).catch(() => {      
             });
      },
      submitFormpwd(){
            this.$refs.ruleFormpwd.validate(async (valid) => {
                if (valid) {
                  var {data:dt} = await updatePassword({
                    newPassword:this.ruleFormpwd.pass,
                    oldPassword:this.ruleFormpwd.oldpass,
                    userId:window.localStorage.getItem('shopId')
                  })
                  console.log(dt)
                  if(dt.code == 200){
                    this.$message.success(dt.message)
                    this.dialogVisiblepwd = false
                    setTimeout(()=>{
                      window.localStorage.removeItem('name')
                      window.localStorage.removeItem('shopId')
                      window.localStorage.removeItem('token')
                      window.localStorage.removeItem('state')
                      this.$router.push('/login')
                    },2000)
                  }else{
                    this.$message.error(dt.message)
                  }
                    
                } 
            });
        }

  }
}
</script>
<style lang="less" scoped>
.left_logo{
  width: 14%;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  float: left;
}
.right_main{
  float: left;
  width: 86%;
  overflow: hidden;
  ul{
    overflow: hidden;
    float: left;
    li{
        float: left;
        padding: 0 25px;
        font-size: 14px;
        line-height: 70px;
        color:#fff;
        opacity: 0.7;
    }
  }
  .head{
    float: right;
    margin-right: 40px;   
  }
  .active{
    color: #fff;
    font-weight: 700;
    font-size: 20px;
    opacity: 1;
  }
  .menu{
    position: absolute;
    top: 70px;
    height: 50px;
    background: #fff;
    width: 100%;
    padding-left: 20px;
    box-sizing: border-box;
    left: 0;
    padding-left: 16%;
    .el-breadcrumb{
      line-height: 50px;
    }
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
      font-weight: 600;
    }
  }

}
  .none{
    display: none!important;
  }
  .block{
    display: block!important;
  }
</style>
<style>
  .home{
    height: 100%;
  }
  .el-header, .el-footer {
    background-color: #268AF0;
    color: #fff;
    text-align: center;
    height: 70px!important;
    line-height: 70px;
    padding: 0!important;
    overflow: hidden;
    
  }
  
  .el-aside {
    background-color:#005BAC;
    color: #333;
    text-align: center;
    width: 14%!important;
        /* z-index: 99999; */
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    margin-top: 50px;
    padding: 15px!important;
  }
  
  .el-container {
    height: 100%!important;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #fff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  /* .el-popper[x-placement^=bottom] {
        margin-top: -15px!important;
   } */
   .el-menu{
     border-right: none;
   }
   .el-submenu{
     text-align: left;
   }
   .el-submenu__title{
     background:#005BAC!important;
   }
   .el-menu-item{
     background:#005BAC!important;
     text-align: left!important;
   }
   .el-menu-item-group__title{
     background: #001529!important;
   }
   .el-menu-item.is-active {
      color: #fff!important;
      background: #18CF84!important;
  }
  .el-menu-item:hover{
    background:#18CF84!important;
  }
  .el-message-box__header{
    border-bottom: 1px solid #eeeeee;
  }
  .el-message-box__title{
    font-size: 16px!important;
  }
  .el-dialog__header {
    padding: 15px 20px 10px;
    border-bottom: 1px solid #eeeeee;
}
.el-dialog__title{
  font-size: 16px;
}
.el-submenu__title i {
    color: #fff;
}
</style>

